module.exports = __webpack_public_path__ + "img/rotationImgFive.2ff0d254.png";